

export const handleVerifyRedirect = (valuesProps, history, idCrianca, redirect, setRadioClick, setAnexarCrianca) => {

  let pagina;

  const anexoId = valuesProps?.tipoAnexo?.id;

  const validDadosPrincipais = new Set([1, 10, 36]);
  const validDocumentacao = new Set([2, 3, 4, 5]);
  const validSituacaoJuridica = new Set([13, 14, 15, 16, 17]);
  const validHistorico = new Set([6, 7, 38, 39, 40]);
  const validSaude = new Set([11, 41]);
  const validProfissionalizacao = new Set([12, 20, 27]);
  const validVisita = new Set([8, 9]);
  const validReferencia = new Set([23]);
  const validEducacao = new Set([22]);

  if (validDadosPrincipais.has(anexoId)) {
    pagina = "/editar"
  } else if (validDocumentacao.has(anexoId)) {
    pagina = "/editar-documentacao"
  } else if (validSituacaoJuridica.has(anexoId)) {
    pagina = "/visualizar-situacao-juridica"
  } else if (validHistorico.has(anexoId)) {
    pagina = "/visualizar-movimentacao"
  } else if (validSaude.has(anexoId)) {
    setRadioClick && setRadioClick("Editar");
    pagina = "/editar-saude"
  } else if (validProfissionalizacao.has(anexoId)) {
    setRadioClick && setRadioClick("Editar");
    setAnexarCrianca && setAnexarCrianca(false);
    pagina = "/editar-profissionalizacao"
  } else if (validVisita.has(anexoId)) {
    pagina = "/visualizar-visitas"
  } else if (validReferencia.has(anexoId)) {
    pagina = "/visualizar-referencia-familiar"
  } else if (validEducacao.has(anexoId)) {
    setRadioClick && setRadioClick("Editar");
    pagina = "/editar-educacao"
  }

  if (pagina) {
    if (redirect) {
      history.push(`/crianca${pagina}/${idCrianca}?idAnexo=${anexoId}`);
    }
    return true;
  }
  return false;
};